export default __webpack_public_path__ + "static/media/893.28c55e31.png";